import cn from "classnames";
import BookShow from "components/shared/book/show";
import { Transition } from "components/shared/column";
import { paths } from "helpers/paths";
import { viewContainer } from "helpers/redux";
import React from "react";
import { Link, Redirect } from "react-router-dom";
import { config, initialState } from "../formConfig";
import Markup from "./markup";

class ShowTracker extends BookShow {
    get dropdActions() {
        return [];
    }

    renderBody = () => {
        const { config } = this.props;
        const { isRoot, isTechSupport, isIntegrationManager } = this.props.roles;
        const props = { ...config, isRoot, isTechSupport, isIntegrationManager };
        return (
            <Markup
                {...props}
                renderField={this.renderField}
                renderSelect={this.renderSelect}
                Button={this.renderButton}
            />
        );
    };

    renderButton = () => {
        const trackerHistoryLink = (
            <div>
                <Link className="btn btn-sm btn-link" to={paths.trackerOdometerValues(this.state.data.id)}>
                    История показаний одометра
                </Link>
                <br />
                <Link className="btn btn-sm btn-link" to={paths.trackerHistory(this.state.data.id)}>
                    Информация о привязке трекера
                </Link>
            </div>
        );

        if (!this.props.canEditBooks) {
            return trackerHistoryLink;
        }
        const cname = cn("btn btn-brand btn-sm", { disabled: !this.state.shouldUpdate });
        return (
            <div className="panel__row justify-content-between align-items-start">
                {trackerHistoryLink}
                <div className={cname} onClick={this.apply}>
                    Обновить
                </div>
            </div>
        );
    };

    render() {
        const { isRoot, isTechSupport, isIntegrationManager } = this.props.roles;
        if (!(isRoot || isTechSupport || isIntegrationManager)) {
            return <Redirect to={paths.trackers} />;
        }
        const { match, location, history, transition } = this.props;
        const cname = cn("book-show__body", { "book-show__body--invalid": !this.state.isValid });
        return (
            <Transition dir={transition || "left"} {...{ match, location, history }}>
                <div className="page-book__show book-show">
                    {this.renderHead()}
                    <div className={cname}>{this.renderBodyWrap()}</div>
                </div>
            </Transition>
        );
    }
}

const ConfiguredShow = (props) => <ShowTracker {...props} config={config(true)} initialState={initialState} />;

export default viewContainer(ConfiguredShow, "trackers");
